/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.run(['$rootScope', '$modal', function ($rootScope, $modal) {
        
        $rootScope.modals = $modal.modals;
        $rootScope.addModal = $modal.addModal;
        
    }]);

}());